import React, { useState, useEffect, useRef } from "react";
import { InformationCircleIcon } from "@heroicons/react/solid";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import moment from "moment";
import { connect } from "react-redux";
import { Lightbox } from "react-modal-image";

import {
  getAllData,
  configureLaunchStep,
  finalStep,
  previousStep,
  createCompleteCampaign,
} from "../../../redux/actions/standard/homeActions";
import {
  Tabs,
  Switch,
  IconButton,
  Button,
  Modal,
  IconInput,
  UpgradeCard,
  ErrorMessage,
} from "../../../components";
import { useSelector } from "react-redux";
import Calendar from "react-calendar";
import ReactTooltip from "react-tooltip";

import AssesstmentReview from "./assesstment";
import "./main.css";
import { tabsData } from "./data";
import { toAbsoluteUrl } from "../../../services";
import HelpButton from "../../../components/button/helpButton";



// get step data from redux main state
const data = (state) => state.standardHome.step4Data;
const allData = (state) => state.standardHome;
// get user data from state
const authMainData = (state) => state.auth;

let ConfigureLaunch = (props) => {
  const calendarRef = useRef(null);
  const authData = useSelector(authMainData);
  const allStepsData = useSelector(allData);

  // savedData
  let savedData = useSelector(data);
  // console.log(savedData, " ====> here is it");
  var isEmpty = Object.entries(savedData).length > 0;
  // let navigate = useNavigate();

  const [upgrade, setUpgrade] = useState(false);
  const [imageModalSurvey, setImageModalSurvey] = useState(false);

  // Tab State Start
  const [activeTab, setActiveTab] = useState(0);
  // Tab State End

  // Candidate Experience State Start
  const [showCandidateSurvey, setCandidateSurvey] = useState(
    isEmpty === true ? savedData.showCandidateSurvey : false
  );
  const [showCandidateVideo, setCandidateVideo] = useState(
    isEmpty === true ? savedData.showCandidateVideo : false
  );
  // Candidate Experience State End

  // Candidate Anti-Cheat Feature State Start
  const [facialRecognition, setFacialRecognition] = useState(
    isEmpty === true ? savedData.facialRecognition : false
  );
  const [gameAutoLock, setGameAutoLock] = useState(
    isEmpty === true ? savedData.gameAutoLock : false
  );
  // Candidate Anti-Cheat Feature State End

  // Modal State Start
  const [openModal, setOpenModal] = React.useState(false);
  // Modal State End

  // Tab State Start
  // const [isCampaign, setIsCampaign] = useState(false);

  // Tab State End
  let { startDate, endDate } = authData?.campaignDates;

  // const [launchDate, setLaunchDate] = useState(startDate);
  // const [closingDate, setClosingDate] = useState(endDate);

  const [launchDate, setLaunchDate] = useState(
    isEmpty === true ? new Date(savedData.launchDate) : null
  );
  const [closingDate, setClosingDate] = useState(
    isEmpty === true ? new Date(savedData.closingDate) : null
  );

  const [handleLaunchCalendar, setLaunchCalendar] = useState(false);

  const [handleClosingCalendar, setClosingCalendar] = useState(false);

  // error handler
  const [dateError, setDateError] = useState(false);
  const [message, setMessage] = useState("");

  //   Tab Handler
  let mainTabHandler = (event, value) => {
    setActiveTab(value);
  };

  let handlePrevious = () => {
    props.previousStep(3);
  };

  let handleModal = (hideModal, isCampaign) => {
    setOpenModal(hideModal);
    props.getAllData(5);
    setTimeout(() => {
      props.createCompleteCampaign(allStepsData);
    }, 1500);
  };

  let handleModalClose = (hideModal, isCampaign) => {
    setOpenModal(hideModal);
  };
  let finalStepHandler = (step) => {
    props.finalStep(step);
  };

  // Handle Next Button Function
  let handleNext = () => {
    if (activeTab < 2) {
      setActiveTab(activeTab + 1);
    }
  };

  // review assessment
  let reviewAssessment = () => {
    if (!launchDate || !closingDate) {
      setDateError(true);
      setMessage("Select launch date and closing date!");
    } else if (launchDate > closingDate) {
      setDateError(true);
      setMessage("Closing date should be greater than Launch Date!");
    } else {
      let data = {
        showCandidateVideo,
        showCandidateSurvey,
        facialRecognition,
        gameAutoLock,
        launchDate,
        closingDate,
      };
      props.configureLaunchStep(data);
      setOpenModal(true);
    }
  };

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };
  // console.log(showCandidateSurvey, "=====> showCandidateSurvey")
  // console.log(showCandidateVideo, "=====> showCandidateVideo")
  // console.log(gameAutoLock, "=====> gameAutoLock")
  // console.log(facialRecognition, "=====> facialRecognition")
  // console.log(launchDate, "=====> launchDate");
  // console.log(closingDate, "=====> closingDate");

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setClosingCalendar(false);
        setLaunchCalendar(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    console.log("stand  configlaunch.js");

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarRef]);

  // useEffect(() => {
  //   let paidCheck = tabsData[activeTab].paid;
  //   if (paidCheck) {
  //     setTimeout(() => {
  //       setUpgrade(!upgrade);
  //     }, 400);
  //   }
  // }, [activeTab]);

  let showSurvey = () => {
    setImageModalSurvey(true);
  };

  return (
    <>
      {openModal ? (
        <Modal open={openModal}>
          <div className="2xl:2/12 bg-white">
            <AssesstmentReview
              handleModalClose={handleModalClose}
              handleModal={handleModal}
              finalStepHandler={finalStepHandler}
            />
          </div>
        </Modal>
      ) : upgrade ? (
        <UpgradeCard type="STANDARD" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-7/12 xl:w-7/12 lg:w-7/12 w-11/12 mb-10">
          <div className="bg-white rounded-md shadow-lg  2xl:px-10 xl:px-10 lg:px-10 px-4 py-8">
            <Tabs onChange={mainTabHandler} current={activeTab} data={tabsData}>
              {activeTab === 0 ? (
                <div>
                  {/* active tab Candidate Experience start */}
                  <span className="text-[#4B4141] font-semibold text-[15px] ">
                    Select from below if you want to add Candidate Experience
                    Survey.
                  </span>
                  <div className="my-6">
                    <div className="mb-6">
                      <div className="flex flex-row justify-start items-center ">
                        <Switch
                          label="Candidate Experience Survey"
                          checked={showCandidateSurvey}
                          onChange={() => {
                            setCandidateSurvey(!showCandidateSurvey);
                          }}
                        />
                        <InformationCircleIcon
                          data-tip={`Enable this if you want your candidates to fill out a survey form that has 6 questions.`}
                          data-for="inCandidateSurvey"
                          className="text-[#007E8C] text-xs h-6 w-6 rounded-full ml-[-12px] mt-0.5 invisible sm:visible lg:visible xl:visible 2xl:visible"
                        />

                        <ReactTooltip
                          id="inCandidateSurvey"
                          place="right"
                          effect="solid"
                          backgroundColor="#007E8C"
                          className="tooltipcustom mt-4 "
                        ></ReactTooltip>
                      </div>
                      <p
                        onClick={() => showSurvey()}
                        className="text-[#007E8C] ml-12 font-normal text-sm underline  border-[#007E8C]"
                      >
                        Click here to see a sample
                      </p>
                    </div>
                    {/* <div>
                      <div className="flex flex-row justify-start items-center">
                        <Switch
                          label="Candidate Tutorial Video"
                          checked={showCandidateVideo}
                          onChange={() =>
                            setCandidateVideo(!showCandidateVideo)
                          }
                        />
                        <InformationCircleIcon
                          data-tip={`Enable this if you want your candidates to see a 'Tutorial Video' about how to attempt online gamified test.`}
                          data-for="inCandidateVideo"
                          className="text-[#007E8C] h-6 w-6 rounded-full ml-[-12px] mt-0.5 invisible sm:visible lg:visible xl:visible 2xl:visible"
                        />

                        <ReactTooltip
                          id="inCandidateVideo"
                          place="right"
                          effect="solid"
                          className="tooltipcustom"
                        ></ReactTooltip>
                      </div>
                      <p className="text-[#007E8C] ml-12 font-normal text-sm underline border-[#007E8C]">
                        click here to watch the video
                      </p>
                    </div> */}
                  </div>
                  {/* active tab Candidate Experience end */}
                </div>
              ) : activeTab === 1 ? (
                <div>
                  {/* active tab Anti-Cheat Feature start */}
                  <span className="text-[#4B4141] font-bold text-lg ">
                    Turn on your preferred anti-cheat feature for candidates
                  </span>
                  <div className="my-6">
                    <div className="mb-6">
                      <div className="flex flex-row justify-start items-center ">
                        <Switch
                          label="Facial Recognition"
                          checked={facialRecognition}
                          disabled={true}
                        // onChange={() =>
                        //   setFacialRecognition(!facialRecognition)
                        // }
                        />
                        {/* <InformationCircleIcon
                            data-tip={`Enable this if you want to monitor a candidate's movement and other activities while taking the gamified assessment.`}
                            data-for="facial"
                            className="text-[#007E8C] h-6 w-6 rounded-full"
                          /> */}

                        <button onClick={() => setUpgrade(!upgrade)}>
                          <img
                            src={toAbsoluteUrl(`/media/login/daimond.png`)}
                            alt="upgrade icon"
                            className={`w-6 object-contain ml-[-6px] mt-0.5`}
                          />
                        </button>

                        {/* <ReactTooltip
                            id="facial"
                            place="right"
                            effect="solid"
                            className="tooltipcustomanticheat"
                          >
  
                          </ReactTooltip> */}
                      </div>
                    </div>
                    <div>
                      <div className="flex flex-row justify-start items-center">
                        <Switch
                          label="Game Auto Lock"
                          checked={gameAutoLock}
                          onChange={() => setGameAutoLock(!gameAutoLock)}
                        />
                        <InformationCircleIcon
                          data-tip={`Enable this if you want to automatically lock the assessment game for candidates who move onto some other tab in the browser or minimize the game while it's in progress.`}
                          data-for="gameLock"
                          className="text-[#007E8C] h-6 w-6 rounded-full ml-[-12px] mt-0.5"
                        />
                        <ReactTooltip
                          id="gameLock"
                          place="right"
                          effect="solid"
                          backgroundColor="#007E8C"
                          className="tooltipcustomanticheat"
                        ></ReactTooltip>
                      </div>
                    </div>
                  </div>
                  {/* active tab Anti-Cheat Feature end */}
                </div>
              ) : activeTab === 2 ? (
                <div>
                  {/* active tab Launch Date start */}
                  <span className="text-[#4B4141] font-bold text-lg ">
                    Please select launching and closing dates
                  </span>
                  <div className="flex justify-between items-start  2xl:flex-row xl:flex-row lg:flex-row flex-col">
                    <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 md:w-6/12 w-11/12">
                      <IconInput
                        label="Launch Date"
                        value={
                          launchDate
                            ? moment
                              .utc(launchDate)
                              .local()
                              .format("YYYY-MM-DD")
                            : ""
                        }
                        placeholder="YYYY-MM-DD"
                        customStyle={"mb-7 "}
                        readOnly={true}
                        onClick={() => {
                          setLaunchCalendar(true);
                          setClosingCalendar(false);
                        }}
                      />

                      <IconInput
                        label="Closing Date"
                        customStyle={"mb-7 w-full"}
                        value={
                          closingDate
                            ? moment
                              .utc(closingDate)
                              .local()
                              .format("YYYY-MM-DD")
                            : ""
                        }
                        placeholder="YYYY-MM-DD"
                        readOnly={true}
                        onClick={() => {
                          setClosingCalendar(true);
                          setLaunchCalendar(false);
                        }}
                      />
                      <Button
                        onClick={reviewAssessment}
                        name="Review Your Assessment Game"
                        customStyle="w-full mt-6"
                      />
                    </div>
                    <div className="2xl:w-5/12 xl:w-5/12 lg:w-5/12 md:w-5/12 2xl:ml-6 xl:ml-6 lg:ml-6 md:ml-6 mt-6  w-11/12 ">
                      <div>
                        {handleLaunchCalendar ? (
                          <div
                            ref={calendarRef}
                            className="flex  justify-end items-end flex-col mt-7 ml-4"
                          >
                            <Calendar
                              calendarType="US"
                              onChange={(value, event) => {
                                setLaunchDate(value);
                                setLaunchCalendar(false);
                              }}
                              defaultValue={launchDate}
                              minDate={new Date()}
                              maxDate={new Date(endDate)}
                              readOnly={true}
                            />
                          </div>
                        ) : null}
                      </div>
                      <div>
                        {handleClosingCalendar ? (
                          <div
                            ref={calendarRef}
                            className="flex  justify-end items-end flex-col mt-7 ml-4"
                          >
                            <Calendar
                              calendarType="US"
                              minDate={new Date()}
                              maxDate={new Date(endDate)}
                              onChange={(value, event) => {
                                setClosingDate(value);
                                setClosingCalendar(false);
                              }}
                              defaultValue={closingDate}
                              readOnly={true}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {dateError ? (
                    <div className="w-max mx-auto mt-6">
                      <ErrorMessage
                        onClick={() => setDateError(false)}
                        text={message}
                      />
                    </div>
                  ) : null}
                  {/* active tab Launch Date end */}
                </div>
              ) : null}
            </Tabs>

            {imageModalSurvey && (
              <Lightbox
                medium={toAbsoluteUrl(`/media/customizeStep/survey.jpeg`)}
                large={toAbsoluteUrl(`/media/customizeStep/survey.jpeg`)}
                alt="Survey Example"
                onClose={() => setImageModalSurvey(false)}
              />
            )}
          </div>
          {/* Handle Next Button */}
          <div className="my-4 flex justify-between">
            <IconButton
              onClick={handlePrevious}
              name="Previous"
              customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 flex-row-reverse bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm  font-semibold  2xl:tracking-[0.1rem] xl:tracking-[0.1rem] "
            >
              <FaAngleLeft className="text-white mr-1 mt-[1px]" />
            </IconButton>
            <div className="text-center">
              <h1 className="font-medium text-xl  text-[#3B4345]">
                Your Current Plan:{" "}
                <b className="font-bold text-xl text-[#007E8C]">STANDARD</b>
              </h1>
              <button
                onClick={() => updatePlan()}
                className="font-medium underline text-[#007E8C] mt-2"
              >
                Upgrade Your Plan
              </button>
            </div>
            {activeTab < 2 ? (
              <IconButton
                onClick={handleNext}
                name="Next"
                customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm font-semibold  tracking-[0.1rem]"
              >
                <FaAngleRight className="text-white mt-[1px]" />
              </IconButton>
            ) : (
              <div className="mr-20"></div>
            )}
          </div>
        </div>
      )}
      <HelpButton screen="login" />F
    </>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getAllData,
  configureLaunchStep,
  finalStep,
  previousStep,
  createCompleteCampaign,
})(ConfigureLaunch);
